import { SliceZone } from '@prismicio/react';

import { PrismicPageQuery } from '@prismic/gqlTypes/prismicOperations';
import { IBreadcrumb, Breadcrumbs } from '@components/molecules/Breadcrumbs';
import React from 'react';
import { components } from './Slices';
import * as S from './styles';

interface PageProps {
  content: PrismicPageQuery['page'];
  breadcrumbs: IBreadcrumb[];
}

const Page: React.FC<PageProps> = ({ content, breadcrumbs }) => {
  const { body, showbreadcrumbs } = content;
  return (
    <S.Wrapper className="prismic-page">
      {showbreadcrumbs && (
        <Breadcrumbs
          breadcrumbs={breadcrumbs}
          useMediaQueries={false}
          showHomeLink={false}
        />
      )}
      <S.Content>
        <SliceZone slices={body} components={components} />
      </S.Content>
    </S.Wrapper>
  );
};

Page.displayName = 'PrismicPage';

export default Page;
